// extracted by mini-css-extract-plugin
export default {"header":"header_header__BGQU0","subTitle":"header_subTitle__pJCle","mr4":"header_mr4__iXwL9"};